<template>
  <div class="calendar-wrapper">
    <v-date-picker
      v-model="selectedDate"
      :min-date="new Date()"
      expanded
      borderless
      @update:modelValue="emitDate"
    />
  </div>
</template>

<script>
import { DatePicker } from 'v-calendar';

export default {
  name: 'calenderGeneral',
  components: {
    VDatePicker: DatePicker,
  },
  emits: ['date-selected'],
  data() {
    return {
      selectedDate: null,
    };
  },
  methods: {
    emitDate(value) {
      if (!value) return;
      const date = new Date(value);
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      this.$emit('date-selected', `${yyyy}-${mm}-${dd}`);
    },
  },
};
</script>

<style scoped>
@import 'v-calendar/dist/style.css';

.calendar-wrapper {
  border: 1px solid #d9e3f3;
  border-radius: 16px;
  padding: 10px;
  background: #fff;
  box-shadow: 0 6px 18px rgba(14, 42, 90, 0.08);
}

:deep(.vc-container) {
  --vc-accent-50: #fff7d0;
  --vc-accent-100: #ffeea3;
  --vc-accent-200: #ffe276;
  --vc-accent-300: #ffd94f;
  --vc-accent-400: #fbc903;
  --vc-accent-500: #fbc903;
  --vc-accent-600: #e5b700;
  --vc-accent-700: #bf9700;
  --vc-accent-800: #8f7100;
  --vc-accent-900: #5f4c00;
  border: 0;
}

:deep(.vc-title),
:deep(.vc-weekday),
:deep(.vc-nav-title) {
  color: #151824;
  font-weight: 700;
}

:deep(.vc-day-content) {
  color: #2d3142;
}

:deep(.vc-day.is-today .vc-day-content) {
  color: #fbc903;
  font-weight: 700;
}
</style>
